<template>
  <div class="root">
    <b-container class="" fluid>
      <b-row>
        <b-col cols="12" class="mb-3 p-0 m-0">
          <b-alert 
            variant="danger"
            :show="!details.org_details.premium_details.hasActivePremium &&
                details.org_details.premium_details.hasFreeTrial"
            dismissible
          >
            Your Free Trial period will end 
            <span v-if="details.org_details.premium_details.freeTrialDaysLeft != 0">
              in
              {{ details.org_details.premium_details.freeTrialDaysLeft }} day{{
                details.org_details.premium_details.freeTrialDaysLeft > 1 ? "s" : ""
              }}
              time.
            </span>
            <span v-if="details.org_details.premium_details.freeTrialDaysLeft == 0">
              today!
            </span>
            <b-link :to="'/upgrade'">Please upgrade to a premium plan</b-link> before your free trial expires to keep your testspaces Opened for your
            candidates.

          </b-alert>
          <div class="flex-div">
            <div class="left-flex-child">
              <div class="l-content">
                <p class="b-header">{{ details.clearance_organization }} Dashboard</p>
                <p class="s-header">Monitor all your Organization's activites here!</p>
              </div>
            </div>
          </div>
        </b-col>

        <b-col cols="12" class="p-0 mt-4">
          <div class="board-wrapper">
            <digit-board
              class="board-items"
              title="No of Tests Taken"
              symbol=""
              :value="analytics?.num_tests_taken"
              color="green"
            ></digit-board>
            <digit-board
              class="board-items"
              title="No of Testspaces"
              symbol=""
              :value="analytics?.num_test_spaces"
              color="green"
            ></digit-board>
            <digit-board
              class="board-items"
              title="No of Testgroups"
              symbol=""
              :value="analytics?.num_test_groups"
              color="green"
            ></digit-board>
            <digit-board
              class="board-items"
              title="No of Candidate Groups"
              symbol=""
              :value="analytics?.num_candidate_groups"
              color="green"
            ></digit-board>
            <digit-board
              class="board-items"
              title="No of Candidates"
              symbol=""
              :value="analytics?.num_candidates"
              color="green"
            ></digit-board>
            <digit-board
              class="board-items"
              title="No of Solid Takers"
              symbol=""
              :value="analytics?.num_tests_takers"
              color="green"
            ></digit-board>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-5">
        <b-col lg="12" class="mt-2">
          <div class="dash-card latestresults p-3">
            <div class="m-3">
              <b-row>
                <b-col cols="7">
                  <p class="card-legend">Latest Scores from Testspaces</p>
                </b-col>
                <b-col cols="5" class="text-right">
                  <b-button
                    :to="{ name: 'listtestspacesorg' }"
                    class="ll"
                    variant="outline-success"
                    >See More</b-button
                  >
                </b-col>
              </b-row>
            </div>
            <b-skeleton-wrapper
              class="text-center"
              :loading="latestScores.length == 0 && fetching2"
            >
              <template #loading>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </template>
              <div v-if="latestScores.length == 0 && fetching2">
                You have not taken any tests Yet!.
                <router-link :to="{ name: 'select' }">Take One!</router-link>
              </div>
              <div v-else>
                  <miniLatestScores
                    v-for="(result, index) in latestScores"
                    :data="result"
                    :fields="['institution', 'candidate_name', 'candidate_email', 'testspace', 'date_ended', 'total_score']"
                    :key="index"
                    class="dash-card-item"
                  >
                    <template #total_score="{ data }">
                      <div class="flex-child">
                        <div class="totsco p-2 result-col">
                            <span :class="[ data.total_score <= 0.45 * data.total_marks ? 'lowscore' : 'highscore' ]" class="red">
                              {{ data.total_score }}
                            </span>/{{ data.total_marks }}
                        </div>
                      </div>
                    </template>
                </miniLatestScores>
              </div>
            </b-skeleton-wrapper>
          </div>
        </b-col>

        <b-col lg="12" class="mt-2">
          <div class="dash-card minischedule p-3">
            <div class="m-3">
              <b-row>
                <b-col cols="7">
                  <p class="card-legend">Ongoing & Upcoming Testspaces</p>
                </b-col>
                <b-col cols="5" class="text-right">
                  <b-button
                    :to="{ name: 'listtestspacesorg' }"
                    class="ll"
                    variant="outline-success"
                    >See More</b-button
                  >
                </b-col>
              </b-row>
            </div>

            <b-skeleton-wrapper class="text-center" :loading="upcomingOngoingTestspaces.length == 0 && fetching3">
              <template #loading>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </template>
              <div v-if="upcomingOngoingTestspaces.length == 0 && fetching3">
                You have not taken any tests Yet!.
                <router-link :to="{ name: 'select' }">Take One!</router-link>
              </div>
              <div v-else>
                  <miniLatestScores
                    v-for="(testspace, index) in upcomingOngoingTestspaces"
                    :data="testspace"
                    :fields="['test_title', 'test_institution', 'test_subjects', 'test_startdate', 'test_enddate', 'test_takers','test_status', 'test_state']"
                    :key="index"
                    class="dash-card-item"
                  >
                    <template #test_subjects="{ data }">
                      <div class="flex-child">
                        <p class="p-2 result-col">{{ JSON.parse(data.test_subjects)?.join(",") }}</p>
                      </div>
                    </template>

                    <template #test_startdate="{ data }">
                      <div class="flex-child">
                        <p class="p-2 result-col">
                          <span>{{ dateFormatter(data.test_startdate) }}</span
                            ><br />
                            <span>{{
                              timeFormatter(
                                `${data.test_startdate} ${data.test_starttime}`
                              )
                            }}</span>
                        </p>
                      </div>
                    </template>

                    <template #test_enddate="{ data }">
                      <div class="flex-child">
                        <p class="p-2 result-col">
                          <span>{{ dateFormatter(data.test_enddate) }}</span
                            ><br />
                            <span>{{
                              timeFormatter(
                                `${data.test_enddate} ${data.test_endtime}`
                              )
                            }}</span>
                        </p>
                      </div>
                    </template>

                    <template #test_takers="{ data }">
                      <div class="flex-child">
                        <p class="p-2 result-col">{{ JSON.parse(data.test_takers)?.join(",")?.length }} Candidates</p>
                      </div>
                    </template>

                    <template #test_status="{ data }">
                      <div class="flex-child">
                        <div class="p-2 result-col">
                          <span>
                            <b-badge
                              :disabled="true"
                              :variant="
                                data.test_status == 'Closed' ? 'danger' : 'success'
                              "
                              >{{ capitalizeString(data.test_status) }}</b-badge
                            >
                          </span>
                        </div>
                      </div>
                    </template>

                    <template #test_state="{ data }">
                      <div class="flex-child">
                        <div class="p-2 result-col">
                          <span>
                            <b-badge
                              :disabled="true"
                              :variant="
                                data.test_state == 'concluded'
                                  ? 'danger'
                                  : data.test_state == 'ongoing'
                                  ? 'success'
                                  : 'info'
                              "
                              >{{ capitalizeString(data.test_state) }}</b-badge
                            >
                          </span>
                        </div>
                      </div>
                    </template>

                    
                </miniLatestScores>
              </div>
            </b-skeleton-wrapper>
          </div>
        </b-col>

      
      </b-row>
    </b-container>
  </div>
</template>

<script>
import miniLatestScores from "@/components/organization/dashboard/miniLatestScores";
import digitBoard from "@/components/digitBoard";
import { mapState, mapActions } from "vuex";
// import store from "@/store"

export default {
  components: {
    miniLatestScores,
    digitBoard,
  },
  data() {
    return {
      dt: new Date(),
      curD: new Date(),
      mainProps: { width: 75, height: 75, class: "m1" },
      data: {},
      analytics: {},
      fetching: false,
      latestScores: [],
      upcomingOngoingTestspaces: [],
      fetching2: false,
      fetching3: false

    };
  },
  mounted() {
    this.retrieveInstitutions();
    this.setCurrentModule("Dashboard");
    this.fetchAnalytics();
    this.fetchLatestScores();
    this.fetchUpcomingOngoingTestspaces();

    this.getInterval = setInterval(() => {
      this.fetchAnalytics();
      this.fetchLatestScores();
      this.fetchUpcomingOngoingTestspaces();
    }, 30000);
  },
  watch: {
    gdata() {
      this.data = this.gdata;
    },
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.getInterval);
    next();
  },
  methods: {
    ...mapActions("exam", ["retrieveInstitutions"]),
    ...mapActions("admin", ["setCurrentModule", "getOrgAnalytics"]),
    ...mapActions("dashboard", ["fetchOrgLatestScores", "fetchOrgUpcomingOngoingTestspaces"]),

    async fetchAnalytics() {
      this.fetching = true;

      try {
        const response = await this.getOrgAnalytics();
        this.analytics = response.data;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchLatestScores() {

      this.fetching2 = true;

      try {
        const response = await this.fetchOrgLatestScores();
        this.latestScores = response.data.data;

        this.fetching2 = false;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchUpcomingOngoingTestspaces() {

      this.fetching3 = true;

      try {
        const response = await this.fetchOrgUpcomingOngoingTestspaces();

        this.upcomingOngoingTestspaces = response.data.data;

        this.fetching3 = false;
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    ...mapState({
      details: (state) => state.loginmaster.details,
      resultsarr: (state) => state.dashboard.lresults,
      donelr: (state) => state.dashboard.donelresults,
      schedulesup: (state) => state.dashboard.upschedules,
      plan: (state) => state.loginmaster.details.plan,
      upschedulesfetched: (state) => state.dashboard.upschedulesfetched,
      miniresultfetched: (state) => state.dashboard.miniresultfetched,
      allinsti: (state) => state.exam.allinstitutions,
      gdata: (state) => state.dashboard.overallgraph,
    }),

    lresultsre() {
      if (this.donelr == false && this.resultsarr.length <= 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.dash-card {
  min-height: 70vh;
  background-color: white;
  border-radius: 20px 20px;
}

.ll {
  text-decoration: none;
  color: black;
  font-size: 0.8rem;
}
.card-legend {
  font-weight: bold;
  font-size: 1.2rem;
}

.mll {
  color: #00377b;
}

.llrs {
  font-size: 0.9rem;
  line-height: 1rem;
  margin-bottom: -10px;
}

.dash-card-item {
  border-radius: 10px 10px;
}
.dash-card-item:hover {
  background-color: #f0f0f0;
}
.v-button {
  border-radius: 10px 10px;
  width: 10rem;
  height: 3rem;
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border: 0px;
  font-size: 18px;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}
.l-content {
  position: relative;
  top: 20%;
}
.flex-div {
  display: flex;
  flex-flow: row wrap;
}
.left-flex-child {
  width: 60%;
}
.right-flex-child {
  width: 40%;
}
.b-header {
  font-size: 32px;
  color: #00984a;
}
.s-header {
  font-size: 20px;
}
.board-wrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  width: 100%;
}
.board-items {
  width: 30%;
  margin: 3px;
}

@media (min-width: 768px) {
}

@media (max-width: 999px) {
  .v-button {
    width: 7rem;
    height: 2.5rem;
    font-size: 1rem;
  }
  .s-header {
    font-size: 16px;
  }
  .board-items {
    width: 40%;
    margin: 3px;
  }
  .b-header {
    font-size: 28px;
  }
}
</style>
